<!-- Revised on 2025/10/16 by mnavarro -->
<template>
  <Button v-if="enableReload" size="xs" color="primary" :title="$t('key_button_reload')" variant="outline" @click="click()">
    <span>
      <i class="fa-solid fa-sync" aria-hidden="true"></i>
    </span>
  </Button>
</template>

<script>

  import Button from "./Button.vue"

  export default {
    name: "ReloadButton",
    components: {
      Button
    },
    props: {
      enableReload: {
        type: Boolean,
        default: true
      },
    },
    emits: ['reload-page'],
    methods: {
      click() {
        this.$emit('reload-page');
      }
    }
  };

</script>